import { Link } from '@reach/router';
import React, { useContext } from 'react';
import { NotebookContext } from '../../context/NotebookContext';
import client from '../../lib/client';
import { deleteNoteMutation, notesQuery } from '../../queries/notes';
import {
  NoteDeleteMutation,
  NoteDeleteMutationVariables
} from '../../queries/__generated__/NoteDeleteMutation';
import { ButtonIconRound } from '../ui';

interface DataCardProps {
  note: {
    id: string;
    measurements: {
      subject: {
        id: string;
      };
      tracker: {
        id: string;
      };
      value: number;
    }[];
    subjects: {
      id: string;
      name: string;
    }[];
  };
  isEntryAuthor: boolean;
}

const EditBar: React.FC<DataCardProps> = ({ note, isEntryAuthor }) => {
  const { notebook } = useContext(NotebookContext);

  async function deleteNote() {
    const confirmDelete = confirm('Are you sure you want to delete this note?');
    if (confirmDelete) {
      await client
        .mutate<NoteDeleteMutation, NoteDeleteMutationVariables>({
          mutation: deleteNoteMutation,
          variables: { input: { id: note.id } },
          refetchQueries: [
            {
              query: notesQuery,
              variables: { input: { notebookId: notebook.id, first: 20 } }
            }
          ]
        })
        .then(data => {
          console.log(data);
          const { errors } = data;
          if (errors) {
            throw new Error(errors[0].message);
          }
        });
    }
  }
  return (
    <>
      {isEntryAuthor && (
        <div className="bt b--light-gray flex items-center ph3 pv2">
          <ButtonIconRound
            as={Link}
            to={`/notebook/note/${note.id}/edit`}
            name="edit"
            iconSize={20}
            className="mr2"
            data-testid="edit-entry-button"
          />
          <ButtonIconRound
            onClick={deleteNote}
            name="trash"
            iconSize={20}
            data-testid="delete-entry-button"
          />
        </div>
      )}
    </>
  );
};

export default EditBar;
